<template>
  <div>
    <form data-vv-scope="step-2-part-1" autocomplete="off" @submit.prevent>
      <div class="row mb-5">
        <div class="col-12">
          <h4>Datos de la persona que ingresa el documento</h4>
        </div>
        <div class="col-md-12">
          <list-user-groups
            class="w-100"
            autocomplete
            only-groups
            label="Grupo al que irá asociado el expediente (*)"
            name="creatorGroup"
            v-model="step.creatorGroup"
            :danger="errors.has('step-2-part-1.creatorGroup')"
            :danger-text="errors.first('step-2-part-1.creatorGroup')"
            v-validate="{ required: userGroupsState.list.length > 1 }"
            ref="creatorGroup"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <h4>Origen / Datos Remitente</h4>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <list-institution-types
            class="w-100"
            autocomplete
            label="Tipo Institución (*)"
            name="institutionType"
            v-model="step.institutionType"
            :danger="errors.has('step-2-part-1.institutionType')"
            :danger-text="errors.first('step-2-part-1.institutionType')"
            v-validate="'required'"
            ref="institutionType"
          />
        </div>
        <div class="col-md-6">
          <list-institutions
            class="w-100"
            autocomplete
            label="Institución"
            name="institution"
            v-model="step.institution"
            :parent-value="step.institutionType"
            ref="institution"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-input
            class="w-100"
            label="Nombre Persona"
            maxlength="50"
            name="personName"
            v-model="step.personName"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <vs-input
            class="w-100"
            label="Cargo Persona"
            maxlength="50"
            name="personPosition"
            v-model="step.personPosition"
            autocomplete="off"
          />
        </div>
        <div class="col-6">
          <vs-input
            class="w-100"
            label="Correo Persona"
            maxlength="70"
            name="personEmail"
            v-validate="'email'"
            :danger="errors.has('step-2-part-1.personEmail')"
            :danger-text="errors.first('step-2-part-1.personEmail')"
            v-model="step.personEmail"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="step-2-part-2" autocomplete="off" @submit.prevent>
      <div class="row mb-3">
        <div class="col-12">
          <h4>Destinatario (*)</h4>
        </div>
      </div>
      <SelectSubjectPublic
        @add-subject="addSubject"
        v-if="!maxSubjectActives"
        need-providence
        filter-me
        :date-limit="step.expirationDate"
      />
      <div class="row mb-3">
        <div class="col-12">
          <TableSubjects
            :subjects="step.subjects"
            v-model="step.subjectsSelected"
          />
        </div>
      </div>
    </form>
      <div class="row mb-3">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
    <form data-vv-scope="step-2-part-3" @submit.prevent>
      <div class="row mb-3">
        <div class="col-12">
          <h4>Con copia a</h4>
        </div>
      </div>
      <SelectCopyPublic
        @add-copy="addCopy"
        :providence-date="providenceDate"
      />
      <div class="row mb-3">
        <div class="col-12">
          <TableCopies
            :copies="step.copies"
            v-model="step.copiesSelected"
          />
        </div>
      </div>
    </form>
    <div class="row mb-3">
      <div class="col-12">
        <vs-divider />
      </div>
    </div>
    <form data-vv-scope="step-2-part-4" autocomplete="off" @submit.prevent>
      <div class="row mb-3">
        <div class="col-md-6">
          <vs-select
            data-cy="annexed"
            class="w-100"
            autocomplete
            label="Anexo"
            name="esFisico"
            v-model="step.withAttachment"
          >
            <vs-select-item
              value="0"
              text="No"
            />
            <vs-select-item
              value="1"
              text="Si"
            />
          </vs-select>
        </div>
        <div class="col-md-6">
          <vs-select
            class="w-100"
            autocomplete
            label="Requiere Respuesta"
            name="requiereResponse"
            v-model="step.requiereResponse"
          >
            <vs-select-item
              value="0"
              text="No"
            />
            <vs-select-item
              value="1"
              text="Si"
            />
          </vs-select>
        </div>
      </div>
      <div class="row mb-3" v-if="validWithAttachment">
        <div class="col-md-6">
          <vs-input
            class="w-100"
            label="Detalle (*)"
            maxlength="250"
            name="documentDetail"
            v-model="step.documentDetail"
            v-validate="{ required: validWithAttachment }"
            :danger="errors.has('step-2-part-4.documentDetail')"
            :danger-text="errors.first('step-2-part-4.documentDetail')"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <vs-input
            class="w-100"
            :label="'Asunto (*)'"
            maxlength="250"
            data-cy="affair"
            name="asunto"
            v-model="step.asunto"
            autocomplete="off"
            v-validate="'required'"
            :danger="errors.has('step-2-part-4.asunto')"
            :danger-text="errors.first('step-2-part-4.asunto')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label for="observation">Observación</label>
          <vs-textarea
            type="text"
            id="observation"
            maxlength="5000"
            label="Observación (5000 caracteres)"
            data-cy="observation"
            name="observacion"
            v-model="step.observation"
            data-vv-as="observación"
            width="100%"
            height="100px"
          />
          <div v-if="errors.first('step-2-part-4.observacion')"
               class="con-text-validation span-text-validation-danger
             vs-input--text-validation-span v-enter-to"
               style="height: 32px;">
            <span class="span-text-validation">
              {{errors.first('step-2-part-4.observacion')}}
            </span>
          </div>
          <div class="text-right">
            <span v-tooltip="'Contador de caracteres'">{{step.observation.length}}/5000</span>
          </div>
        </div>
      </div>
      <div v-if="error.message !== ''" class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to text-right"
           style="height: 32px;">
          <span class="span-text-validation">
            {{error.message}}
          </span>
      </div>
    </form>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import ListInstitutions from '@/febos/chile/lists/components/ListInstitutions';
import ListInstitutionTypes from '@/febos/chile/lists/components/ListInstitutionTypes';
import ListUserGroups from '@/febos/chile/lists/components/ListUserGroups';
import SelectCopyPublic from '@/febos/chile/dnt/components/wizard/subjects/SelectCopyPublic';
import TableSubjects from '@/febos/chile/dnt/components/wizard/subjects/TableSubjects';
import TableCopies from '@/febos/chile/dnt/components/wizard/subjects/TableCopies';
import SelectSubjectPublic from '@/febos/chile/dnt/components/wizard/subjects/SelectSubjectPublic';

const MAX_SUBJECTS = 1;

export default {
  mixins: [WizardStep],
  components: {
    SelectSubjectPublic,
    ListInstitutionTypes,
    ListInstitutions,
    ListUserGroups,
    SelectCopyPublic,
    TableSubjects,
    TableCopies
  },
  data() {
    return {
      error: {
        message: ''
      },
      providenceDate: '',
      emailRequired: ['personas', 'empresas', 'ministerios'],
      isInput: ['personas', 'empresas'],
      subjectForm: {
        subjectType: '',
        subject: '',
        subjectTypeDigitalDoc: '',
        subjectEmail: '',
      },
      copySubjectForm: {
        copySubjectType: '',
        copySubject: '',
        copySubjectTypeDigitalDoc: '',
        copySubjectEmail: '',
      },
      step: {
        creatorGroup: '',
        institutionType: '',
        institution: '',
        personName: '',
        personPosition: '',
        personEmail: '',
        personPhone: '',
        withAttachment: '0',
        documentDetail: '',
        asunto: '',
        observation: '',
        subjects: [],
        copies: [],
        subjectsSelected: [],
        copiesSelected: [],
        requiereResponse: '1',
        ...this.draft
      },
      counterDanger: false
    };
  },
  watch: {
    subjects(newValue) {
      this.subjectsSelected = newValue;
      this.subjects = newValue;
    },
    copies(newValue) {
      this.copiesSelected = newValue;
      this.copies = newValue;
    },
    institutionTypesState(newValue) {
      if (newValue && newValue.list.length > 0) {
        const defaultInstitution = newValue.list.find((institution) => institution.value === 'SISS');
        if (defaultInstitution) {
          this.step.institutionType = defaultInstitution.value;
        }
      }
    }
  },
  computed: {
    ...mapGetters('List', [
      'institutionTypesState'
    ]),
    ...mapGetters('List', [
      'userGroupsState'
    ]),
    ...mapGetters('Dnts', [
      'wizardData'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    validWithAttachment() {
      // eslint-disable-next-line
      return !!parseInt(this.step.withAttachment);
    },
    maxSubjectActives() {
      return this.step.subjectsSelected && this.step.subjectsSelected.length >= MAX_SUBJECTS;
    }
  },
  methods: {
    async addSubject(row) {
      if (row.subject.id === this.currentUser.id) {
        this.$bvToast.toast(
          'No te puedes agregar como destinatario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }

      const isSelected = this.step.subjectsSelected
        .some((subjectRow) => {
          if (subjectRow.subjectType.value === 'docDigital') return subjectRow.subjectTypeDigitalDoc.id === row.subjectTypeDigitalDoc.id;

          return subjectRow.subject.id === row.subject.id;
        });
      this.providenceDate = row.providenceExpiration;
      if (!isSelected) {
        this.step.subjects.push(row);
        this.step.subjectsSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste este destinatario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    async addCopy(row) {
      if (row.copySubject.id === this.currentUser.id) {
        this.$bvToast.toast(
          'No te puedes agregar como copia',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }
      const isSelected = this.step.copiesSelected
        .some((copyRow) => {
          if (copyRow.copySubjectType.value === 'docDigital') return copyRow.copySubjectTypeDigitalDoc.id === row.copySubjectTypeDigitalDoc.id;

          return copyRow.copySubject.id === row.copySubject.id;
        });
      if (isSelected) {
        this.$bvToast.toast(
          'Ya agregaste esta copia',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }

      this.step.copies.push(row);
      this.step.copiesSelected.push(row);
    },
    async isValid() {
      const stepValidations = await Promise.all([
        this.validateForm('step-2-part-1'),
        this.validateForm('step-2-part-4'),
      ]);

      if (stepValidations.some((step) => !step)) {
        return false;
      }

      if (!this.step.subjectsSelected.length) {
        this.error.message = 'Debes agregar al menos un destino';
        return false;
      }
      if (this.step.subjectsSelected.length > MAX_SUBJECTS) {
        this.error.message = 'Debes agregar solo un destino';
        return false;
      }

      return true;
    },
    getStepData() {
      const institutionTypeName = this.step.institutionType
        ? {
          institutionTypeName: this.$refs.institutionType.getOption()?.label
        }
        : {};

      const institutionName = this.step.institution
        ? {
          institutionName: this.$refs.institution.getOption()?.label
        }
        : {};

      const creatorGroupName = this.step.creatorGroup
        ? {
          creatorGroupName: this.$refs.creatorGroup.getOption()?.label
        }
        : {};

      return {
        ...this.step,
        ...institutionTypeName,
        ...institutionName,
        ...creatorGroupName
      };
    }
  },
  created() {
    const recentSender = localStorage.getItem('sender');
    if (recentSender) {
      const sender = JSON.parse(recentSender);
      this.step.personName = sender.name;
      this.step.personPosition = sender.position;
    }
    if (this.userGroupsState.list.length === 1) {
      this.step.creatorGroup = this.userGroupsState.list[0].id;
      this.step.creatorGroupName = this.userGroupsState.list[0].label;
    }
    const institution = this.institutionTypesState.list
      .find((institutionType) => institutionType?.value === 'SISS');
    if (institution && institution.value) {
      this.step.institutionType = institution.id;
    }
    // Esto se usa desde un principio como descripción de flujo, no borrar
    this.step.resumen = (this.wizardData.matter || '').slice(0, 50);
  }
};

</script>
